"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ListView;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ListView(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "View_manipulation",
    "data-name": "View manipulation"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "list-view"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M89.864,22.214H42.136a2.5,2.5,0,0,1,0-5H89.864a2.5,2.5,0,0,1,0,5ZM32.229,27.578V11.849a4.5,4.5,0,0,0-4.5-4.5H12a4.5,4.5,0,0,0-4.5,4.5V27.578a4.5,4.5,0,0,0,4.5,4.5H27.729A4.5,4.5,0,0,0,32.229,27.578ZM12.5,12.349H27.229V27.078H12.5ZM92.364,50a2.5,2.5,0,0,0-2.5-2.5H42.136a2.5,2.5,0,1,0,0,5H89.864A2.5,2.5,0,0,0,92.364,50ZM32.229,57.864V42.136a4.5,4.5,0,0,0-4.5-4.5H12a4.5,4.5,0,0,0-4.5,4.5V57.864a4.5,4.5,0,0,0,4.5,4.5H27.729A4.5,4.5,0,0,0,32.229,57.864ZM12.5,42.636H27.229V57.364H12.5Zm79.864,37.65a2.5,2.5,0,0,0-2.5-2.5H42.136a2.5,2.5,0,1,0,0,5H89.864A2.5,2.5,0,0,0,92.364,80.286ZM32.229,88.151V72.422a4.5,4.5,0,0,0-4.5-4.5H12a4.5,4.5,0,0,0-4.5,4.5V88.151a4.5,4.5,0,0,0,4.5,4.5H27.729A4.5,4.5,0,0,0,32.229,88.151ZM12.5,72.922H27.229V87.651H12.5Z"
  }))));
}